<template>
  <notification
    type="is-danger"
    icon="fa-exclamation-circle"
    @delete="$emit('delete')"
    snackbar
  >
    Wystąpił błąd podczas próby nawiązania połączenia z serwerem.
  </notification>
</template>

<script>
import { Notification } from "%notifications";

export default {
  name: "connection-failed-notification",

  components: {
    Notification
  }
};
</script>

<style></style>
